import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2fd9fa54"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Follow up questions", -1))
const _hoisted_2 = {
  key: 0,
  class: "skeleton",
  "aria-busy": "true",
  "aria-live": "polite"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "skeleton-paragraph",
  role: "status",
  "aria-label": "Loading suggested follow-on questions..."
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "skeleton-paragraph",
  role: "status",
  "aria-label": "Loading suggested follow-on questions..."
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "skeleton-paragraph",
  role: "status",
  "aria-label": "Loading suggested follow-on questions..."
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "skeleton-paragraph",
  role: "status",
  "aria-label": "Loading suggested follow-on questions..."
}, null, -1))
const _hoisted_7 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "source-outer"
}
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (_ctx.suggestionsLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_7))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (Array.isArray(_ctx.followOnQuestions) && _ctx.followOnQuestions.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.followOnQuestions, (question, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "source",
                    key: index
                  }, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "follow-on-question",
                      onClick: _withModifiers(($event: any) => (_ctx.askQuestion(question)), ["prevent"])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(question), 1)
                    ], 8, _hoisted_10)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
  ], 64))
}